// extracted by mini-css-extract-plugin
export default {"description":"style_description__2hj24"};